import { useState } from "react";
import { Flame } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useVault } from "@/context/VaultContext";

export function WipeDialog({ open, onOpenChange }) {
  const { wipe } = useVault();
  const [text, setText] = useState("");
  return (
    <Dialog open={open} onOpenChange={(o) => { setText(""); onOpenChange(o); }}>
      <DialogContent data-testid="wipe-dialog" className="bg-nebula border-flare/30 text-ash sm:max-w-sm rounded-secure">
        <DialogHeader>
          <DialogTitle className="font-branding flex items-center gap-2 text-flare"><Flame size={18} strokeWidth={1.5} /> Panic wipe</DialogTitle>
          <DialogDescription className="text-ash/55">Destroys every vault on this device — real and decoy — including keys, chats and files. This cannot be undone.</DialogDescription>
        </DialogHeader>
        <input data-testid="wipe-confirm-input" value={text} onChange={(e) => setText(e.target.value)} placeholder="Type WIPE to confirm"
          className="w-full bg-void border border-rim rounded-secure px-3 py-2.5 text-sm focus:outline-none focus:border-flare/60" />
        <button data-testid="wipe-confirm-btn" disabled={text !== "WIPE"} onClick={async () => { await wipe(); onOpenChange(false); }}
          className="w-full bg-flare text-void font-branding font-semibold rounded-secure py-2.5 disabled:opacity-40 transition-opacity">Destroy everything</button>
      </DialogContent>
    </Dialog>
  );
}
